import { Link } from "react-router-dom";
import { FileBarChart, Timer } from "lucide-react";
import { AppShell } from "@/components/shell/AppShell";
import { EmptyState } from "@/components/kit";

export default function ReportsPage() {
  return (
    <AppShell>
      <div className="mk-fade mb-6">
        <h1 data-testid="reports-title" className="font-heading text-3xl font-extrabold tracking-tight text-thstrong sm:text-4xl">Reports <span className="ml-1 text-lg font-semibold text-thcyan">Exports & Decks</span></h1>
        <p className="mk-label mt-2 tracking-[0.25em]">Scheduled and on-demand report surfaces</p>
      </div>
      <EmptyState testid="reports-empty" icon={FileBarChart} title="No reports yet"
        body="Module dashboards are built live from your monthly uploads. Styled PPT/PDF exports and scheduled digests will appear here as they are published." />
      <p className="mk-sub mt-6 flex items-center gap-2">
        <Timer className="h-3 w-3" /> Looking for AHT benchmark decks? <Link to="/aht" data-testid="reports-aht-link" className="text-thcyan hover:underline">Open AHT Analytics</Link>
      </p>
    </AppShell>
  );
}
